import { FlowPatientDataStoreEndpoint, FlowProducedType } from 'flow-schema';

import { api } from 'common';

import { PatientDataStoreFormFields } from './FormFields';
import { PatientDataStoreDocumentationMarkdown } from './documentation';
import { ProducedType } from '../../../types';
import { type BlockConfigProps } from '../../types';

type PatientDataStoreBlockConfig = api.FlowDefinition.PatientDataStore.PatientDataStoreBlockConfig;

export const PatientDataStoreConfig: BlockConfigProps<PatientDataStoreBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'SmartFetchFromChart',
  defaultConfig: {
    endpoint: FlowPatientDataStoreEndpoint.DocumentMetadata,
    patient: {
      sourceBlockName: '',
      consumesType: FlowProducedType.Patient,
    },
    returnType: ProducedType.PdsDocumentMetadata,
  },
  configFields: {
    schema: api.FlowDefinition.PatientDataStore.PatientDataStoreConfigSchema,
    FormFields: PatientDataStoreFormFields,
  },
  documentationMarkdown: PatientDataStoreDocumentationMarkdown,
};
